import { render } from "./testimonials-modal.vue?vue&type=template&id=727980cb"
import script from "./testimonials-modal.vue?vue&type=script&lang=js"
export * from "./testimonials-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__